module.exports = __webpack_public_path__ + "media/images/img-usage-button-e252b84cfbff39dfffa28164152c485e.png";